/**
 * DomainConfigPage - Domain configuration management
 *
 * Surfaces the DomainConfigurationManager from @ferp/workflow-forms for architect users.
 * Provides domain-agnostic configuration management across subgraphs.
 *
 * Route: /admin/domain-config
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';

import { DomainConfigurationManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function DomainConfigPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="gray">
            <IconSettings size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Domain Configuration</Title>
            <Text size="sm" c="dimmed">
              Domain-agnostic configuration management across subgraphs
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <DomainConfigurationManager tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default DomainConfigPage;
